// 登入、驗證相關 API（使用 authRequest，public 端點）
import authRequest from '../core/authRequest';

/**
 * 以 teachable_id / email 登入，取得 access token
 * @param {{ teachable_id: string, email: string }} payload - 登入資料
 * @returns {Promise<LoginResponse>}
 * @see {@link ./types.js} LoginResponse
 */
const apiPostLogin = (payload) => authRequest.post('/v1/user/login/teachable', payload);

/**
 * 以 httpOnly cookie 中的 refresh token 換取新的短效 access token（效期 1 小時）。
 * 每次成功都會輪替 refresh token cookie；送出已被輪替的舊 token 會觸發 reuse detection 並撤銷整個 session（401）。
 * 為 public 端點，不需 Authorization，但需 XSRF-Token（由 authRequest 的 xsrf 設定自動帶上）。
 * @returns {Promise<RefreshTokenResponse>}
 * @see {@link ./types.js} RefreshTokenResponse
 */
// _isRefreshCall 標記讓 response interceptor 略過此請求的 401 自動刷新流程，避免遞迴
const apiPostUserTokenRefresh = () => authRequest.post('/v1/user/token/refresh', null, { _isRefreshCall: true });

export default {
  apiPostLogin,
  apiPostUserTokenRefresh,
};
